import { useState } from 'react';
import { FormControlLabel, Switch, TextField } from '@mui/material';
import CustomButton from '../../reusable/CustomButton';
import { saveDSASettings } from '../../../services/eoaConfigServices';
import useUserDetails from '../../hooks/useUserDetails';
import { DSASettingsData } from '../../../interfaces/EOAInterface';
import useErrorModal from '../../hooks/useErrorModal';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';

import './DSASettings.css';

function DSASettings() {
  const {
    userDetails: { data: userDetails },
  } = useUserDetails();
  const { handleOpen: handleOpenErrorModal } = useErrorModal();
  const navigate = useNavigate();

  const [isDSASigned, setIsDSASigned] = useState(false);
  const [signatureDate, setSignatureDate] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [desctructionDate, setDestructionDate] = useState('');
  const [documentUrl, setDocumentUrl] = useState('');

  const handleSaveDSASettings = async () => {
    if (userDetails) {
      try {
        let DSASettings: DSASettingsData = {
          signed_executed: isDSASigned,
          signature_date: signatureDate,
          start_date: startDate,
          end_date: endDate,
          data_destruction_date: desctructionDate,
          document_url: documentUrl,
        };
        await saveDSASettings(userDetails.access_token, userDetails.eoaId, DSASettings);
        navigate('/eoa');
      } catch (error) {
        handleOpenErrorModal('Error occurred while saving DSA settings!', error as AxiosError);
      }
    } else {
      handleOpenErrorModal('User details missing!', new Error('User details missing!'));
    }
  };

  return (
    <div className="dsa-settings">
      <h3>DSA Settings</h3>
      <FormControlLabel
        control={<Switch value={isDSASigned} onChange={(event) => setIsDSASigned(event.target.checked)} />}
        label="DSA Signed and Executed"
        labelPlacement="start"
      />
      {isDSASigned ? (
        <>
          <FormControlLabel
            control={
              <input type="date" value={signatureDate} onChange={(event) => setSignatureDate(event.target.value)} />
            }
            label="Signature date"
            labelPlacement="start"
          />
          <FormControlLabel
            control={<input type="date" value={startDate} onChange={(event) => setStartDate(event.target.value)} />}
            label="Start date"
            labelPlacement="start"
          />
          <FormControlLabel
            control={<input type="date" value={endDate} onChange={(event) => setEndDate(event.target.value)} />}
            label="End date"
            labelPlacement="start"
          />
          <FormControlLabel
            control={
              <input
                type="date"
                value={desctructionDate}
                onChange={(event) => setDestructionDate(event.target.value)}
              />
            }
            label="Destruction date"
            labelPlacement="start"
          />
          <TextField
            required
            label="Document Url"
            variant="outlined"
            value={documentUrl}
            onChange={(event) => setDocumentUrl(event.target.value)}
          />
          <CustomButton
            variant="primary"
            size="medium"
            buttonText="Save Settings"
            buttonAction={handleSaveDSASettings}
          />
        </>
      ) : null}
    </div>
  );
}

export default DSASettings;
